import * as React from "react";
const SvgFiRrWalletArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-wallet-arrow_svg__a)">
      <path
        fill="#062147"
        d="M20 16a1.5 1.5 0 1 1-3.001 0A1.5 1.5 0 0 1 20 16m3-8a1 1 0 0 0-1 1v12c0 .551-.448 1-1 1H5c-1.654 0-3-1.346-3-3V8.995A5 5 0 0 0 4.999 10h10a1 1 0 1 0 0-2H5a3 3 0 0 1-2.217-1.004A2.98 2.98 0 0 1 5 6h7a1 1 0 1 0 0-2H5C2 4 0 6.5 0 9v10c0 2.757 2.243 5 5 5h16c1.654 0 3-1.346 3-3V9a1 1 0 0 0-1-1m-6.297-3.789L18 2.931V9a1 1 0 1 0 2 0V2.947l1.303 1.268a.998.998 0 1 0 1.394-1.432L20.47.616A2.107 2.107 0 0 0 17.5.612L15.296 2.79a1 1 0 0 0 1.406 1.423z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-wallet-arrow_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWalletArrow;
